import * as ko from "knockout";

import BrandedPage from "../brandedPage";
import TeamMember from "../../teamMember";

import "./aboutUs.less";
import * as joHouse from '../../images/JoHouse.png';
import * as adamBushnell from '../../images/AdamBushnell.png';
import * as danMonk from '../../images/DanMonk.png';
import * as jamesBritton from '../../images/JamesBritton.png';
import * as timOver from '../../images/TimOver.png';
import * as danielBridge from '../../images/DanielBridge.png';


class Index extends BrandedPage {
    
    public readonly selectedTeamMember: ko.Observable<TeamMember> = ko.observable(null);
    public readonly teamMembers: ko.ObservableArray<TeamMember> = ko.observableArray([
        new TeamMember(this.selectedTeamMember,
            "Joanne House",
            "Practice Director",
            "With over 25 years' utility experience Joanne was pivotal in setting up our AtkinsRéalis Utility Solutions business back in 2002 and has led the ongoing success, growth and development of the business since this date. Jo provides the vision and strategy for continued growth, keeping AtkinsRéalis Utility Solutions at the forefront of the utility industry.",
            joHouse),
        new TeamMember(this.selectedTeamMember,
            "Adam Bushnell",
            "Practice Manager",
            "With a background in construction and project management and 10 years in the utility industry, Adam holds a depth of technical expertise that underpins the AtkinsRéalis Utility Solutions business. Adam defines and develops the strategy of the business, introducing our lifecycle approach to utility management and supporting the changing requirements of our clients in a complex industry. Adam was our representative on the steering groups for PAS 128 and PAS 256.",
            adamBushnell),
        new TeamMember(this.selectedTeamMember,
            "Dan Monk",
            "Systems & Technology Manager",
            "As an experienced and qualified IT professional with over 15 years gained working across a spectrum of markets Dan defines the technology strategy for the business. Applying his breadth of technical consultancy skills, software architecture, agile project management, domain expertise in information systems and full software lifecycle knowledge he is helping to architect the future of AtkinsRéalis Utility Solutions.",
            danMonk),
        new TeamMember(this.selectedTeamMember,
            "Jay Britton",
            "Project Manager",
            "Jay is our Project Manager, responsible for ensuring we deliver products and services to the highest standard. With 8 years' experience with AtkinsRéalis Utility Solutions, Jay and the delivery team strive to deliver quality-assured services that meet our customers' needs, including bespoke solutions to support throughout the project lifecycle.",
            jamesBritton),
        new TeamMember(this.selectedTeamMember,
            "Tim Over",
            "Account Manager",
            "Tim manages key accounts many of which are involved in the design of major infrastructure projects across the UK, whilst regularly attending surveying and architecture CPD events as acting secretary for the Chartered Institution of Civil Engineering Surveyors (CICES). Tim applies his strong interpersonal skills to understand client needs whilst having a keen interest in how digital technology will aid improvements in the utility industry.",
            timOver),
        new TeamMember(this.selectedTeamMember,
            "Daniel Bridge",
            "Account Manager",
            "With over 10 years' experience in client-facing roles, Dan always looks to provide exceptional customer service.  Dan prides himself on building strong, long-lasting relationships founded on understanding customer and project needs, using his problem solving skills to introduce the best technical solutions from our wealth of experience in the utilities sector.",
            danielBridge),
    ]);
    
    public readonly showMeetTheTeam: ko.Computed<boolean> = ko.computed(() => !this.selectedTeamMember());
    public readonly showMeetTheTeamDetail: ko.Computed<boolean> = ko.computed(() => !!this.selectedTeamMember());
}

(new Index()).initialiseAsync();